import React from 'react';
import { Button, Form, Input, DatePicker, message, Select } from 'antd';
import axios from 'axios';
import Header from './header.jsx';
import Sidebar from './sidebar.jsx';

export const AddInvoice = () => {
  // Handle form submission
  const handleSubmit = async (values) => {
    const payload = {
      invoiceDate: values.invoiceDate.format('YYYY-MM-DD'),
      pageLength: values.pageLength, // Already an array of strings
      pageSendingPersonOrOrganization: values.pageSendingPersonOrOrganization,
      pageSendingLocation: values.pageSendingLocation,
      subject: values.subject,
    };

    try {
      await axios.post('https://ward3-chandrapur-api.palikaapp.com/api/invoice/save', payload);
      message.success('चलानी सफलतापूर्वक सुरक्षित गरियो');
    } catch (error) {
      message.error('चलानी सुरक्षित गर्न असफल।');
    }
  };

  return (
    <div className="flex flex-col lg:flex-row min-h-screen bg-gray-100">
      {/* Sidebar */}
      <div className="lg:w-1/5 bg-gray-100">
      <Header />
      </div>

      {/* Main Content */}
      <div className="lg:w-4/5 p-6 pt-20">
      
        <Sidebar />
        <h1 className="text-xl lg:text-2xl font-bold mt-5 lg:mt-16 text-center lg:text-center">
          चलानीको फार्म
        </h1>
        <div className="flex justify-center mt-10">
          <Form
            onFinish={handleSubmit}
            className="w-full max-w-lg bg-white p-6 shadow-lg rounded-md"
            layout="vertical"
          >
            <Form.Item
              label="चलानी मिति"
              name="invoiceDate"
              rules={[{ required: true, message: 'कृपया चलानी मिति छान्नुहोस्' }]}
            >
              <DatePicker className="w-full border-gray-300 rounded-md" />
            </Form.Item>

            <Form.Item
              label="पत्रको प्रकार"
              name="pageLength"
              rules={[{ required: true, message: 'कृपया पृष्ठको लम्बाई लेख्नुहोस्' }]}
            >
              <Select
                mode="tags"
                style={{ width: '100%' }}
                placeholder="पृष्ठको लम्बाई लेख्नुहोस्"
              />
            </Form.Item>

            <Form.Item
              label="व्यक्ति/संस्था"
              name="pageSendingPersonOrOrganization"
              rules={[{ required: true, message: 'कृपया व्यक्ति वा संस्था लेख्नुहोस्' }]}
            >
              <Input className="border-gray-300 rounded-md" />
            </Form.Item>

            <Form.Item
              label="स्थान"
              name="pageSendingLocation"
              rules={[{ required: true, message: 'कृपया स्थान लेख्नुहोस्' }]}
            >
              <Input className="border-gray-300 rounded-md" />
            </Form.Item>

            <Form.Item
              label="विषय"
              name="subject"
              rules={[{ required: true, message: 'कृपया विषय लेख्नुहोस्' }]}
            >
              <Input className="border-gray-300 rounded-md" />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="w-full bg-blue-500 hover:bg-blue-600 text-white font-medium rounded-md"
              >
                चलानी सुरक्षित गर्नुहोस्
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
};
